import {
  ArrowRightCircleIcon,
  AssociatedDeviceIcon,
  GridEnabledIcon,
} from '@hivewatch/dark'
import type { StatusPillVariant } from '@hivewatch/dark'

import { DeviceType } from '@/graphql/generated/schemas'

export type AssociatedDeviceRow = {
  id: string
  name: string
  status: AssociationStatus
  deviceType: DeviceType
  connectionId: string
}

export type AssociationStatus =
  | 'associated'
  | 'grid-enabled'
  | 'tailgate-enabled'

export type GridItem = {
  isTailgateEnabled?: boolean | null
  door?: { id: string } | null
  inBox?: unknown | null
}

export const STATUS_CONFIG: Record<
  AssociationStatus,
  {
    label: string
    variant: StatusPillVariant
    icon: React.ReactNode
    tooltip?: string
  }
> = {
  associated: {
    label: 'Associated',
    variant: 'teal',
    icon: <AssociatedDeviceIcon />,
  },
  'grid-enabled': {
    label: 'Grid-enabled',
    variant: 'teal-blue',
    icon: <GridEnabledIcon />,
  },
  'tailgate-enabled': {
    label: 'Tailgate-enabled',
    variant: 'teal-green',
    icon: <ArrowRightCircleIcon />,
  },
}
